import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { FiBell } from "react-icons/fi";
import { FiLogOut } from "react-icons/fi";
import { useEffect, useState } from "react";
import api from "../utils/api";
import NotificationPanel from "../components/NotificationPanel";

export default function DashboardLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const linkClass = (path) =>
    `block w-full font-bold pl-3 py-3 transition hover:bg-blue-100 hover:text-blue-600 hover:border-r-3 hover:border-blue-700 rounded ${
      pathname === path ? "bg-blue-100 text-blue-600" : ""
    }`;

  const handleLogout = async () => {
    try {
      const confirmLogout = window.confirm("Are you sure you want to log out?");

      if (!confirmLogout) return;
      await api.post("/users/logout", {}, { withCredentials: true });
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  useEffect(() => {
    api
      .get("/users/me", {
        withCredentials: true,
      })
      .then((res) => {
        setEmail(res.data.email);
        setRole(res.data.role);
      })
      .catch((err) => console.error("Axios error:", err));
  }, []);

  return (
    <div className="flex">
      <nav className="fixed top-0 left-0 h-screen w-56 bg-white border-r border-gray-200">
        <div className="flex flex-col h-full">
          <Link to="/" className="p-3 border-b border-gray-200">
            <img
              alt="bit logo"
              src="/bit.png"
              width={200}
              height={200}
              className="rounded-full"
            />
          </Link>

          <ul className="mt-4 mr-4">
            <li>
              <Link to="/dashboard" className={linkClass("/dashboard")}>
                Dashboard
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/products"
                className={linkClass("/dashboard/products")}
              >
                Product List
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/contracts"
                className={linkClass("/dashboard/contracts")}
              >
                Contract List
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/earnings"
                className={linkClass("/dashboard/earnings")}
              >
                Earning List
              </Link>
            </li>
            <li>
              <Link
                to="/dashboard/payouts"
                className={linkClass("/dashboard/payouts")}
              >
                Payout List
              </Link>
            </li>
            {role === "Manager" || role === "Admin" ? (
              <>
                <li>
                  <Link
                    to="/dashboard/users"
                    className={linkClass("/dashboard/users")}
                  >
                    User List
                  </Link>
                </li>
                <li>
                  <Link
                    to="/dashboard/cron-activities"
                    className={linkClass("/dashboard/cron-activities")}
                  >
                    Cron List
                  </Link>
                </li>
              </>
            ) : (
              <></>
            )}
          </ul>
          <div className="mt-auto p-4 border-t border-gray-200">
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 font-bold py-3 text-red-600 hover:bg-red-500 hover:text-white rounded"
            >
              Logout
              <FiLogOut size={16} />
            </button>
          </div>
        </div>
      </nav>

      <div className="flex-1 ml-56">
        <div className="fixed top-0 left-56 right-0 h-16 z-50 bg-gray-100 border-b border-slate-200 flex justify-end items-center px-4">
          <button
            onClick={() => setIsNotificationOpen(true)}
            className="px-2 py-2 flex items-center rounded-full hover:bg-slate-300 transition"
          >
            <div className="relative w-6 h-6">
              <FiBell size={18} className="text-gray-700 cursor-pointer" />

              <div className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" />
            </div>
          </button>
          <div className="px-4 flex items-center text-sm text-gray-700">
            {email}
          </div>
        </div>

        <main className="pt-16 p-4">
          <Outlet />
        </main>

        <NotificationPanel
          isOpen={isNotificationOpen}
          onClose={() => setIsNotificationOpen(false)}
        />
      </div>
    </div>
  );
}
